import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  faqList: [],
};

export const faqSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {
    getFaqs: (state, action) => {
      state.faqList = action.payload;
    },
  },
});

export const selectFaqData = (state) => state.faq.faqList;
export const { getFaqs } = faqSlice.actions;
export default faqSlice.reducer;
